module.exports = require("@comparaonline/ui-forms-validators/dist/validators/chile/validateRut");